export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/modular_systems_booth.48dc209.svg";